import { IsNumber, IsOptional, IsString } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

export class CorrectEquipmentCheckRecordDto {
  @IsNumber()
  temperature!: number;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  reason?: string;
}
